import { SEOHead } from '@components/seo';
import { LastWhimPage } from '@screens/checkout/last-whim';

export default function LastWhim() {
  return (
    <>
      <SEOHead title="Meki · Ultimo antojo" />
      <LastWhimPage />
    </>
  );
}
